var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5252 0.140625C3.42092 0.140625 0.902344 2.6592 0.902344 5.76348C0.902344 8.86777 3.42092 11.3863 6.5252 11.3863C9.62949 11.3863 12.1481 8.86777 12.1481 5.76348C12.1481 2.6592 9.62949 0.140625 6.5252 0.140625ZM9.41863 4.40463L6.1152 7.71977C6.00977 7.8252 5.85749 7.89548 5.7052 7.89548C5.55292 7.89548 5.40063 7.83691 5.2952 7.71977L3.63177 6.05634C3.39749 5.82205 3.39749 5.45891 3.63177 5.22463C3.86606 4.99034 4.2292 4.99034 4.46349 5.22463L5.7052 6.46634L8.59863 3.57291C8.83292 3.33863 9.19606 3.33863 9.43034 3.57291C9.65292 3.8072 9.65292 4.17034 9.41863 4.40463Z",
    fill: "#127E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniCheck);
export default __webpack_public_path__ + "static/media/miniCheck.d83646a5.svg";
export { ForwardRef as ReactComponent };